var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a, _b, _c;
import React from "react";
export var GlobleLoaderContext = React.createContext(function (loader) { });
export var createHash = function (str) { return __awaiter(void 0, void 0, void 0, function () {
    var encoder, data, hashBuffer, hashArray, hashHex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                encoder = new TextEncoder();
                data = encoder.encode(str);
                return [4 /*yield*/, crypto.subtle.digest("SHA-256", data)];
            case 1:
                hashBuffer = _a.sent();
                hashArray = Array.from(new Uint8Array(hashBuffer));
                hashHex = hashArray
                    .map(function (byte) { return byte.toString(16).padStart(2, "0"); })
                    .join("");
                return [2 /*return*/, hashHex];
        }
    });
}); };
export var clearStorageOnLogout = function () {
    localStorage.removeItem("acc_data");
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("lgnSrc");
    localStorage.removeItem("guest_acc_data");
    localStorage.removeItem("consentList");
    localStorage.removeItem("cnsList");
    localStorage.removeItem("accountCode");
};
export var reports = "/newreports/";
export var EReportRoutes;
(function (EReportRoutes) {
    EReportRoutes["dashboard"] = "dashboard";
    EReportRoutes["holding"] = "holding";
    EReportRoutes["positions"] = "positions";
    EReportRoutes["positionSqrOff"] = "positionSqrOff";
    EReportRoutes["orderbook"] = "orderbook";
    EReportRoutes["profitandloss"] = "profitandloss";
    EReportRoutes["downloadReport"] = "download-report";
    EReportRoutes["tax"] = "tax";
    EReportRoutes["contractNotes"] = "contract-notes-statements";
    EReportRoutes["subscriptionHistory"] = "subscription-history";
    EReportRoutes["marginReport"] = "margin-report";
    EReportRoutes["ledgerReport"] = "ledger-report";
    EReportRoutes["dpBills"] = "dp-bills";
    EReportRoutes["dpInterest"] = "dp-interest";
    EReportRoutes["transactionHistory"] = "transaction-history";
    EReportRoutes["dpTransaction"] = "dp-transaction";
})(EReportRoutes || (EReportRoutes = {}));
// paths
export var forBetalive = true;
var opClientReportPaths = (_a = {},
    _a[EReportRoutes.transactionHistory] = reports + EReportRoutes.transactionHistory,
    _a[EReportRoutes.dpTransaction] = reports + EReportRoutes.dpTransaction,
    /********************** tax =dev-in-progress  &  dashboard=upcoming  ******************/
    _a[EReportRoutes.dashboard] = reports + EReportRoutes.dashboard,
    _a[EReportRoutes.tax] = reports + EReportRoutes.tax,
    /*************************** common download & email for new reports*******************/
    _a[EReportRoutes.downloadReport] = reports + EReportRoutes.downloadReport,
    /***************************paths to show other reports independently  after tax, position and dashboard goes beta live******************/
    _a[EReportRoutes.contractNotes] = reports + EReportRoutes.contractNotes,
    _a[EReportRoutes.subscriptionHistory] = reports + EReportRoutes.subscriptionHistory,
    _a[EReportRoutes.ledgerReport] = reports + EReportRoutes.ledgerReport,
    _a[EReportRoutes.dpBills] = reports + EReportRoutes.dpBills,
    _a[EReportRoutes.dpInterest] = reports + EReportRoutes.dpInterest,
    _a);
var betaLiveReportPaths = (_b = {},
    /****************** As dashboard=upcoming & tax=dev-in-progress , we are showing existing ************************/
    _b[EReportRoutes.dashboard] = "/reports",
    _b[EReportRoutes.tax] = "/reports?reportName=Tax",
    /*************************** Existing Other reports , rebranded but also in live **********************************/
    _b[EReportRoutes.dpBills] = "/reports?reportName=otherReports&tab=dpbills",
    _b[EReportRoutes.contractNotes] = "/reports?reportName=otherReports&tab=contract-notes",
    _b[EReportRoutes.subscriptionHistory] = "/reports?reportName=otherReports&tab=subscription-history",
    _b[EReportRoutes.ledgerReport] = "/reports?reportName=otherReports&tab=ledger-report",
    _b[EReportRoutes.dpInterest] = "/reports?reportName=otherReports&tab=delayed-payment-interest",
    _b);
var selectedReportPaths = forBetalive ? betaLiveReportPaths : opClientReportPaths;
export var reportsRoutePaths = __assign((_c = {}, _c[EReportRoutes.orderbook] = reports + EReportRoutes.orderbook, _c[EReportRoutes.holding] = reports + EReportRoutes.holding, _c[EReportRoutes.positions] = reports + EReportRoutes.positions, _c[EReportRoutes.profitandloss] = reports + EReportRoutes.profitandloss, _c[EReportRoutes.marginReport] = "/reports?reportName=otherReports&tab=margin-report", _c), selectedReportPaths);
